import { getAffiliateGoods } from './getAffiliateGoods';
import { getAffiliateAiContentEligibility } from './getAffiliateAiContentEligibility';
import { postAffiliateLinksAccessLogs } from './postAffiliateLinksAccessLogs';

export const affiliateService = {
  getAffiliateGoods,
  getAffiliateAiContentEligibility,
  postAffiliateLinksAccessLogs,
};
